import styled from 'styled-components';

export const Container = styled.div`
  .profile-image {
    width: 50px;
    height: 50px;
    margin: 0 auto;
    background-size: cover;
    background-color: #eaeaea;
    background-position: center;
    border-radius: 100px;
  }
`;

export const Table = styled.table`
  text-align: center;
  margin-bottom: 0;

  td,
  th {
    vertical-align: middle;
  }

  .btn-small {
    padding: 1px 7px;
    font-size: 12px;
    margin: 0 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/Promoters/styles.js